export default __webpack_public_path__ + "static/media/title_vi_pc.8c3d506f.png";